import script from "./BlockInputCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockInputCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./BlockInputCheckbox.vue?vue&type=style&index=0&id=413ade74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413ade74"]])

export default __exports__